export default __webpack_public_path__ + "static/media/products-2-m.d71d67fd.webp";